import { render, staticRenderFns } from "./LOLPositionDan.vue?vue&type=template&id=1af7fffc&scoped=true"
import script from "./LOLPositionDan.vue?vue&type=script&lang=js"
export * from "./LOLPositionDan.vue?vue&type=script&lang=js"
import style0 from "./LOLPositionDan.vue?vue&type=style&index=0&id=1af7fffc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af7fffc",
  null
  
)

export default component.exports